import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Alert } from '@app/alerts-technical';
import { isNil } from 'lodash';

@Injectable()
@Pipe({
    name: 'translateAlert',
})
export class TranslateAlertPipe implements PipeTransform {
    constructor(private readonly translate: TranslateService) {}

    transform(alert: Alert | null | undefined): string {
        if (alert?.algorithmReason === 'TechnicalAlertTriggeredByAdmin') {
            return this.translate.instant('alertDescription.technicalAlertTriggeredByAdmin');
        }

        if (alert?.algorithmReason === 'TechnicalAlertTriggeredByCompany') {
            return this.translate.instant('alertDescription.technicalAlertTriggeredByCompany');
        }

        if (isNil(alert?.algorithmId)) return '';

        return this.translate.instant('alertDescription.' + alert.algorithmId.replace('.', ','), alert.algorithmDescription);
    }
}
